import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Error.scss';

const Error500 = () => {
  useEffect(() => {
    // 500 에러 페이지 애니메이션 효과
    const visual = document.getElementById('visual');
    const events = ['resize', 'load'];
    
    events.forEach(function(e){
      window.addEventListener(e, function(){
        const ratio = 45;
        visual.style.transform = `translate(-50%, -50%) rotate(-${ratio}deg)`;
      });
    });

    return () => {
      events.forEach(function(e){
        window.removeEventListener(e, function(){});
      });
    };
  }, []);

  return (
    <div className="error-page-container">
      <Link to="/" className="error-link">
        <svg height="0.8em" width="0.8em" viewBox="0 0 2 1" preserveAspectRatio="none">
          <polyline
            fill="none"
            stroke="#777777"
            strokeWidth="0.1"
            points="0.9,0.1 0.1,0.5 0.9,0.9"
          />
        </svg> Home
      </Link>
      <div className="background-wrapper">
        <h1 id="visual">500</h1>
      </div>
      <p className="error-text">Ooops...<br/>Internal Server Error.</p>
    </div>
  );
};

export default Error500;